let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gSbWh")).then(() => parcelRequire('AFwEY'));